import Heading from "components/heading/Heading";
import React, { FC } from "react";
import img from "images/mapa.webp";
import Image from "componentsTemplate/Image";
import { Banner, InstitutionalResponse, Text } from "services/PageService";
const urlBase = process.env.REACT_APP_BACKEND_API_URL + '/storage/images/institutional/banners/';

export interface Statistic {
  id: string;
  heading: string;
  subHeading: string;
}

export interface SectionStatisticProps {
  institutional: InstitutionalResponse | null;
}

const SectionStatistic: FC<SectionStatisticProps> = ( institutional ) => {

  const FOUNDER_DEMO: Statistic[] = [
    {
      id: "1",
      heading: institutional?.institutional?.texts?.find((e : Text) => e.name == 'Numero de mulheres')?.text ?? '-',
      subHeading:
        "Impactadas diretamente trocando informações valiosas de saúde, beleza, serviços, viagem e cultura.",
    },
    {
      id: "2",
      heading: institutional?.institutional?.texts?.find((e : Text) => e.name == 'Numero de negócios')?.text ?? '-',
      subHeading: "Realizados.",
    },
    {
      id: "3",
      heading: institutional?.institutional?.texts?.find((e : Text) => e.name == 'Numero de conexões')?.text ?? '-',
      subHeading:
        "Indicações de produtos e serviços.",
    },
  ];

  return (
    <div className={`nc-SectionStatistic relative`}>
      <Heading
        desc={institutional?.institutional?.texts?.find((e : Text) => e.name == 'Subtitulo do banner de alcance')?.text}
      >
        {institutional?.institutional?.texts?.find((e : Text) => e.name == 'Nosso Alcance')?.text}
      </Heading>

      <div className="grid md:grid-cols-2 gap-5 lg:grid-cols-3 xl:gap-8">
        {FOUNDER_DEMO.map((item) => (
          <div
            key={item.id}
            className="p-6 bg-primary-600 dark:bg-black/20 rounded-2xl dark:border-neutral-800"
          >
            <h3 className="text-2xl font-semibold leading-none text-neutral-50 md:text-4xl dark:text-neutral-200">
              {item.heading}
            </h3>
            <span className="block text-sm text-neutral-50 mt-3 sm:text-base dark:text-neutral-400">
              {item.subHeading}
            </span>
          </div>
        ))}
      </div>

      <div className="mt-5">
        <Image
          alt="hero"
          sizes="(max-width: 768px) 100vw, 50vw"
          src={urlBase + institutional?.institutional?.banners?.find((e : Banner) => e.name == 'Banner alcance')?.banner_path}
        />
      </div>
    </div>
  );
};

export default SectionStatistic;
